// src/components/PersonalInfoProtection.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';

const PersonalInfoProtection: React.FC = () => (
    <Box sx={{ p: 2, textAlign: 'left' }}>
        <Typography variant="h5" gutterBottom>
            個人情報保護方針
        </Typography>
        <Typography variant="body2" paragraph>
            当社は、個人情報保護法および関連するガイドラインを遵守し、ユーザーの権利利益を尊重します。
        </Typography>
        <Typography variant="subtitle1">1. 管理体制</Typography>
        <Typography variant="body2" paragraph>
            個人情報保護管理者を任命し、組織的・人的・物理的・技術的安全管理を実施します。
        </Typography>
        <Typography variant="subtitle1">2. 安全管理措置</Typography>
        <Typography variant="body2" paragraph>
            - アクセス制御
            - 暗号化通信（HTTPS、PayPal API 連携時の TLS）
            - 定期的なリスク評価と改善
        </Typography>
        <Typography variant="subtitle1">3. 外部委託</Typography>
        <Typography variant="body2" paragraph>
            業務委託先にも同等の安全管理を義務付け、適切に監督します。
        </Typography>
        <Typography variant="subtitle1">4. 開示・訂正等の手続</Typography>
        <Typography variant="body2" paragraph>
            ユーザーからの開示・訂正・利用停止等の請求には、本人確認のうえ、速やかに対応します。
        </Typography>
        <Typography variant="subtitle1">5. 継続的改善</Typography>
        <Typography variant="body2" paragraph>
            本方針は定期的に見直し、改善します。
        </Typography>
    </Box>
);

export default PersonalInfoProtection;
